import React, { useContext } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { FormikErrors } from 'formik';
import { useCustomCompareEffect, usePrevious } from 'react-use';
import { TriggerScrollToSurveyItemContext } from './Contexts';
import { useNotify } from '../../../hooks';

const messages = defineMessages({
  errorsExist: {
    id: 'ErrorScrollWrapper.errorsExist',
    defaultMessage: 'Errors still exist on this survey page',
  },
});

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type ErrorScrollWrapperOwnProps = {
  errors: FormikErrors<Record<string, any>>;
  isSubmitting: boolean;
};

export type ErrorScrollWrapperProps = ErrorScrollWrapperOwnProps;

const ErrorScrollWrapper: React.FC<ErrorScrollWrapperProps> = ({
  children,
  errors,
  isSubmitting,
}) => {
  const { formatMessage } = useIntl();
  const triggerScrollToItem = useContext(TriggerScrollToSurveyItemContext);
  const prevIsSubmitting = usePrevious(isSubmitting);
  const [notify] = useNotify();
  useCustomCompareEffect(
    () => {
      const errorLinkId = Object.keys(errors)?.[0];
      if (isSubmitting || !prevIsSubmitting || !errorLinkId) return;

      triggerScrollToItem(errorLinkId);
      notify(formatMessage(messages.errorsExist), 'error');
    },
    [isSubmitting, errors, notify, triggerScrollToItem],
    ([prevIsSubmitting], [curIsSubmitting]) => {
      return prevIsSubmitting !== true && prevIsSubmitting === curIsSubmitting;
    },
  );

  return children as any;
};

export default ErrorScrollWrapper;
